document.addEventListener("DOMContentLoaded", function() {
    if (!document.querySelector('variant-picker')) {
        const productData = JSON.parse(document.getElementById('product-data').textContent);
        const firstVariant = productData.formatted[0];
        const variantsFields = firstVariant.metafields.custom.variants_fields;
        const properties = firstVariant.metafields.custom.properties;
        const propertiesBlock = document.querySelector('.properties .properties_block');
        propertiesBlock.innerHTML = '';

        let sortedProperties = [...properties].sort((a, b) => a.pos - b.pos);
        let displayedCategories = new Set();
        let allContent = '';

        sortedProperties.forEach(property => {
            if (variantsFields.hasOwnProperty(property.variable) && property.ausblenden != true) {
                let value = variantsFields[property.variable];
                let isURL = /^(https?:\/\/[^\s]+)$/.test(value);
                let propertyContent = isURL 
                    ? `<a href="${value}" target="_blank">Download</a>` 
                    : value;

                let categoryContent = '';
                if (!displayedCategories.has(property.kategorie)) {
                    categoryContent = `<h3 class="property-title mb-6">${property.kategorie}</h3>`;
                    displayedCategories.add(property.kategorie);  
                }

                let content = `
                    <div class="properties flex justify-between">
                        ${categoryContent}
                        <div class="flex justify-between flex-wrap">
                            <div class="title">${property.titel}</div>
                            <div class="property">${propertyContent}</div>
                        </div>
                    </div>`;

                allContent += content;
            }
        });

        propertiesBlock.innerHTML = allContent;

        const detailsDisclosures = document.querySelectorAll('details-disclosure');

        detailsDisclosures.forEach(function (detailsDisclosure) {
            const propertiesBlock = detailsDisclosure.querySelector('.properties_block');

            if (propertiesBlock) {
            const propertiesDivs = propertiesBlock.querySelectorAll('.properties');

            if (propertiesDivs.length === 0) {
                detailsDisclosure.classList.add('hidden');
            }
            }
        });
    } else {
        const detailsDisclosures = document.querySelectorAll('details-disclosure');
        
        detailsDisclosures.forEach(function (detailsDisclosure) {
            const propertiesBlock = detailsDisclosure.querySelector('.properties_block');
        
            if (propertiesBlock) {
            const propertiesDivs = propertiesBlock.querySelectorAll('.properties');
        
            if (propertiesDivs.length === 0) {
                detailsDisclosure.classList.add('hidden');
            }
            }
        });
    }
});
